module.exports = __webpack_public_path__ + "static/media/expand_icon.923236cc.svg";